import { render, staticRenderFns } from "./CustomTableEdit.vue?vue&type=template&id=f2283352&scoped=true"
import script from "./CustomTableEdit.vue?vue&type=script&lang=js"
export * from "./CustomTableEdit.vue?vue&type=script&lang=js"
import style0 from "./CustomTableEdit.vue?vue&type=style&index=0&id=f2283352&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2283352",
  null
  
)

export default component.exports